import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Promo Code', prop: 'promo_code_id', references: 'admin/promo_codes', referenceProp: 'code' },
  { title: 'Discount', prop: 'discount_id', references: 'admin/discounts', referenceProp: 'code' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by promo code', prop: 'filters.promo_code_id', type: 'autocomplete', references: 'admin/promo_codes', referenceProp: 'code', enabled: true },
  { name: 'Filter by discount', prop: 'filters.discount_id', type: 'autocomplete', references: 'admin/discounts', referenceProp: 'code', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const PromoCodeDiscounts = (props) => (
  <List
    title='Promo Code Discounts'
    apiPath='admin/promo_code_discounts'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default PromoCodeDiscounts
